import React from 'react';
import PropTypes from 'prop-types';

import { getTranslation } from 'common/react/utils/translations';

import { FixtureLinkButton } from './FixtureLinkButton';
import { FixtureMatchReportLink } from './FixtureMatchReportLink';

export const FixtureLinks = ({
    match,
    matchStatus,
    metadata = {},
    broadcastGuideUrl,
    reportLabel
}) => {
    const hasFreeEntry = metadata.free_entry === 'true' ? true : false;

    const renderUpcomingTicketLinks = () => {
        let ticketLink = {};

        if (metadata.ticket_link && !hasFreeEntry) {
            ticketLink = {
                icon: 'tickets-new',
                label: getTranslation('label.fixtures.buy-tickets'),
                href: metadata.ticket_link,
                target: '_blank',
                cssClass: 'fixtures__link-button--alt'
            };

            return <FixtureLinkButton {...ticketLink} />;
        }
    };

    const renderUpcomingOrLiveTicketLinks = () => {
        let broadcastGuideLink = {};
        let playerStatsLink = {};

        // only show a broadcast guide link if the match is assigned to a broadcaster match-event
        if (
            broadcastGuideUrl &&
            matchStatus === PULSE.app.common.CONSTANTS.MATCH_STATUS.LIVE
        ) {
            broadcastGuideLink = {
                icon: 'live-broadcast',
                label: getTranslation('label.fixtures.broadcastGuide'),
                href: broadcastGuideUrl,
                target: '_blank',
                theme: 'live',
            };

            playerStatsLink = {
                icon: 'player-stats',
                label: getTranslation('label.fixtures.player-stats'),
                href:
                    PULSE.app.common.url.getMatchURL(match.id) +
                    '#player-stats',
                target: '_blank',
                theme: 'live'
            };

            return (
                <>
                    <FixtureLinkButton {...playerStatsLink} />
                    <FixtureLinkButton {...broadcastGuideLink} />
                </>
            );
        }

        // only show a broadcast guide link if the match is assigned to a broadcaster match-event
        if (
            broadcastGuideUrl &&
            matchStatus !== PULSE.app.common.CONSTANTS.MATCH_STATUS.LIVE
        ) {
            broadcastGuideLink = {
                icon: 'live-broadcast',
                label: getTranslation('label.fixtures.broadcastGuide'),
                href: broadcastGuideUrl,
                target: '_blank'
            };

            return <FixtureLinkButton {...broadcastGuideLink} />;
        }

        // show Player Stats button if no broadcast guide, stream exists and match is live
        if (
            !broadcastGuideUrl &&
            matchStatus === PULSE.app.common.CONSTANTS.MATCH_STATUS.LIVE
        ) {
            playerStatsLink = {
                icon: 'player-stats',
                label: getTranslation('label.fixtures.player-stats'),
                href:
                    PULSE.app.common.url.getMatchURL(match.id) +
                    '#player-stats',
                target: '_blank',
                theme: 'live'
            };

            return <FixtureLinkButton {...playerStatsLink} />;
        }
    };

    const renderUpcomingTravelLinks = () => {
        let travelLink = {};

        if (metadata.travel_link) {
            travelLink = {
                icon: 'plane',
                label: getTranslation('label.fixtures.travel'),
                href: metadata.travel_link,
                target: '_blank'
            };

            return <FixtureLinkButton {...travelLink} />;
        }
    };

    return (
        <>
            {matchStatus ===
                PULSE.app.common.CONSTANTS.MATCH_STATUS.COMPLETED && ( // check match status
                <FixtureMatchReportLink
                    match={match}
                    reportLabel={reportLabel}
                />
            )}

            {matchStatus === PULSE.app.common.CONSTANTS.MATCH_STATUS.UPCOMING &&
                renderUpcomingTicketLinks()}

            {(matchStatus ===
                PULSE.app.common.CONSTANTS.MATCH_STATUS.UPCOMING ||
                matchStatus === PULSE.app.common.CONSTANTS.MATCH_STATUS.LIVE) &&
                renderUpcomingOrLiveTicketLinks()}

            {matchStatus === PULSE.app.common.CONSTANTS.MATCH_STATUS.UPCOMING &&
                renderUpcomingTravelLinks()}
        </>
    );
};

FixtureLinks.propTypes = {
    match: PropTypes.object,
    matchStatus: PropTypes.string,
    metadata: PropTypes.object,
    regionIsAus: PropTypes.bool,
    reportLabel: PropTypes.string,
    broadcastGuideUrl: PropTypes.string
};
